import React from 'react';
import PropTypes from 'prop-types';
import MainAdUnitContainer
from '@fuww/library/src/Advertisement/MainAdUnitContainer';
import { MobileAdUnitContainer }
from '@fuww/library/src/Advertisement/AdUnitContainer';
import { useSiteContext } from '../../SiteContext';
import hasMoreFeaturedNews, {
  hasMoreNews,
} from '../../../lib/hasMoreFeaturedNews';
import AdUnit, { hasAdunit } from '../../../lib/adunit';
import getMoreNewsRows from '../../../lib/getMoreNewsRows';
import InView from '../../InView';
import MoreFeaturedNews from './Featured/MoreFeaturedNews';
import MoreNewsSection from './MoreNews';

const AdditionalNewsSections = ({
  variables,
  moreNewsVariables,
  notInIds,
  showCreatedAt,
  expandedSections,
  showLoader,
  categorySection,
}) => {
  const { newsboard, locale } = useSiteContext();

  return (
    <>
      {hasAdunit(newsboard) && (
        <MainAdUnitContainer>
          <AdUnit
            adUnit="home_leaderboard1"
            sizes={[[1, 1], [728, 90], [970, 90], [970, 250]]}
            minHeight="90px"
          />
        </MainAdUnitContainer>
      )}
      {expandedSections && hasMoreFeaturedNews(locale) && (
        <MoreFeaturedNews
          variables={{
            ...variables,
            offset: 4,
          }}
          showCreatedAt={showCreatedAt}
          skip={showLoader}
          notInIds={notInIds}
        />
      )}
      {hasMoreNews(newsboard) && (
        <MoreNewsSection
          variables={{
            ...moreNewsVariables,
            notInIds,
          }}
          skip={showLoader}
          showCreatedAt={showCreatedAt}
          rows={expandedSections ? getMoreNewsRows(locale) : undefined}
        />
      )}
      {hasAdunit(newsboard) && (
        <>
          <MainAdUnitContainer>
            <AdUnit
              adUnit="home_leaderboard2"
              sizes={[[1, 1], [728, 90], [970, 90], [970, 250]]}
              minHeight="90px"
            />
          </MainAdUnitContainer>
          <MobileAdUnitContainer>
            <AdUnit
              adUnit="mobile_home_categories_above"
              sizes={[[320, 240], [300, 250]]}
              minHeight="240px"
            />
          </MobileAdUnitContainer>
        </>
      )}
      {categorySection && (
        <InView>
          {categorySection}
        </InView>
      )}
      {hasAdunit(newsboard) && (
        <MobileAdUnitContainer>
          <AdUnit
            adUnit="mobile_home_categories_below"
            sizes={[[320, 240], [300, 250]]}
            minHeight="240px"
          />
        </MobileAdUnitContainer>
      )}
    </>
  );
};

AdditionalNewsSections.propTypes = {
  variables: PropTypes.shape({}).isRequired,
  moreNewsVariables: PropTypes.shape({}),
  notInIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  showCreatedAt: PropTypes.bool,
  expandedSections: PropTypes.bool.isRequired,
  showLoader: PropTypes.bool,
  categorySection: PropTypes.node,
};

AdditionalNewsSections.defaultProps = {
  categorySection: null,
  moreNewsVariables: {},
  showCreatedAt: false,
  showLoader: true,
};

export default AdditionalNewsSections;
